<template>
  <app-layout>
    <v-container fluid>
      <admin-documents></admin-documents>
    </v-container>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import AdminDocuments from '../components/AdminDocuments.vue';

export default {
  components: {
    AppLayout,
    AdminDocuments,
  },
};
</script>
